import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ListadoEmbarques() {
  const { user } = useContext(AuthContext);
  // Costos de compra sólo con el permiso Ver costos en compras
  const verCostos = !!user.verCostosCompras;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;

  let date = new Date();
  date.setDate(date.getDate()-10);
  let hoy = moment(date).format("YYYY-MM-DD");

  const [numeroEmbarque, setNumeroEmbarque] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");
  const [selectedTipo, setSelectedTipo] = useState("");

  const [fechaEmbarque, setFechaEmbarque] = useState("");
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [contenedor, setContenedor] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [idNotaCxP, setIdNotaCxP] = useState("");
  const [noFactura, setNoFactura] = useState("");

  const [articulosOC, setArticulosOC] = useState([]);
  const [articulos, setArticulos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);
  const [totalCaptura, setTotalCaptura] = useState(1000000);

  const [gastosEmbarque, setGastosEmbarque] = useState([]);
  const [modalEditGastos, setModalEditGastos] = useState(false);
  const toggleEditGastos = () => setModalEditGastos(!modalEditGastos);
  const [total_cantidadGastos, setTotalCantidadGastos] = useState(0);
  const [conceptosGastos, setConceptosGastos] = useState([]);

  // Estados para precosteo / costeo Kasher
  const [modalEditFOBKasher, setModalEditFOBKasher] = useState(false);
  const toggleEditFOBKasher = () => setModalEditFOBKasher(!modalEditFOBKasher);
  const [articulosPedido, setArticulosPedido] = useState([]);
  const [tipoCambio, setTipoCambio] = useState(0);
  const [tipoCambioGastos, setTipoCambioGastos] = useState(0);
  const [totalGastoPrecosteo, setTotalGastoPrecosteo] = useState(0);
  const [costeadoEdit, setCosteadoEdit] = useState("No");
  // Tipo del embarque en costeo (Kasher aplica IGI+IVA, Taref no)
  const [tipoEmbarque, setTipoEmbarque] = useState("Taref");
  // % de IVA del costeo. No siempre es 16, se captura por embarque.
  const [ivaPorcentaje, setIvaPorcentaje] = useState(16);
  // Nota general de la carga de gastos del embarque (campo observacionesGastos
  // del embarque, no de cada concepto).
  const [observacionesGastos, setObservacionesGastos] = useState("");
  // Visto bueno de que los gastos del embarque están completos: es lo que
  // habilita costear con confianza.
  const [gastosValidados, setGastosValidados] = useState("No");

  const [totalCantidad, setTotalCantidad] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);

  const [inputFieldsGastos, setInputFieldsGastos] = useState([
    {
      id: uuidv4(),
      concepto: "",
      estimado: 0,
      real: 0,
    },
  ]);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoTotal: 0,
      proveedorOrden: "",
    },
  ]);

    const [inputFieldsNuevos, setInputFieldsNuevos] = useState([
    {
      id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoTotal: 0,
        proveedorOrden: idProveedor,
        ordenCompra: "",
        CBM: 0,
        costoUSD: 0,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,
        igiPorcentaje: 15,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);

  const [modalEditTC, setModalEditTC] = useState(false);
  const toggleEditTC = () => setModalEditTC(!modalEditTC);
  const [articulosEmbTC, setArticulosEmbTC] = useState([]);
  const [idEmbarqueTC, setIdEmbarqueTC] = useState("");
  const [contenedorEdit, setContenedorEdit] = useState("");
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [totalCantidadEdit, setTotalCantidadEdit] = useState("");
  const [totalGeneralEdit, setTotalGeneralEdit] = useState("");
  const [agrupado, setAgrupado] = useState([]);
  const [idArtEdit, setIdArtEdit] = useState("");
  const [recibidoEdit, setRecibidoEdit] = useState("");
  const [tipoEdit, setTipoEdit] = useState("Taref");

  // Default: si venimos desde /BotonesAlmacen con ?filtro=proximo, arrancar filtrado.
  // Filtro por activo/cancelado. Default: solo activos.
  const [activo, setActivo] = useState("Si");
  const [recibido, setRecibido] = useState(() => {
    if (typeof window === "undefined") return "";
    const q = new URLSearchParams(window.location.search);
    return q.get("filtro") === "proximo" ? "Proximo" : "";
  });

  // Si entramos desde MenuAlmacen (?filtro=proximo) la vista es de consulta:
  // en Acciones solo se muestra el PDF, el resto de botones se ocultan.
  const soloConsulta = useMemo(() => {
    if (typeof window === "undefined") return false;
    return new URLSearchParams(window.location.search).get("filtro") === "proximo";
  }, []);

  // El gerente de almacén no tiene el módulo de Embarques (trae costos,
  // brokers y edición), pero sí necesita el listado de contenedores próximos
  // y el PDF de conteo. Con el permiso contenedoresAlmacen entra, pero
  // ÚNICAMENTE en modo consulta.
  const accesoAlmacen = soloConsulta && user.contenedoresAlmacen;
  const puedeVer = user.embarques || accesoAlmacen;
  const puedeAcciones = user.menu_compras || accesoAlmacen;

  //--- Pagination
  const [comments, setComments] = useState([]);
  // W9: archivos
  const [modalArchivos, setModalArchivos] = useState(false);
  const [archivosEmbarque, setArchivosEmbarque] = useState([]);
  const [archivosEmbarqueId, setArchivosEmbarqueId] = useState("");
  const [archivosEmbarqueNum, setArchivosEmbarqueNum] = useState("");
  const [archivoNombre, setArchivoNombre] = useState("");
  const [archivoUrl, setArchivoUrl] = useState("");
  const [archivoFile, setArchivoFile] = useState(null);
  const [previewArchivo, setPreviewArchivo] = useState(null);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmbarques = response.data;
        // Array para pagination
        let arrayTabla = allEmbarques
          .sort((a, b) => (a.idEmbarques > b.idEmbarques ? 1 : -1))
          .map((a) => {
            // if(a.total_cantidad > 0){
            return {
              recibido: a.recibido,
              activo: a.is_active || "Si",
              _id: a._id,
              numero: a.idEmbarques,
              fechaEmbarque: a.fechaEmbarque,
              fechaEstimada: a.fechaEstimada,
              observaciones: a.observaciones,
              contenedor: a.contenedor,
              totalCantidad: Number(a.total_cantidad || 0).toFixed(2),
              // Cajas y tarimas los calcula el back a partir de los renglones
              observacionesGastos: a.observacionesGastos || "",
              gastosValidados: a.gastosValidados || "No",
              totalCajas: Number(a.totalCajas || 0),
              totalTarimas: Number(a.totalTarimas || 0),
              articulosSinTarima: Number(a.articulosSinTarima || 0),
              recibido: a.recibido,
              noFactura: a.noFactura,
              tipoCambioUSDMXN: a.tipoCambioUSDMXN || 0,
              total_gasto: parseFloat(a.total_gasto || 0).toFixed(2),
              total_costo: parseFloat(a.total_costo || 0).toFixed(2),
              costeado: a.costeado || "No",
              ivaPorcentaje: a.ivaPorcentaje == null ? 16 : a.ivaPorcentaje,
              tipoCambioGastos: Number(a.tipoCambioGastos) > 0 ? Number(a.tipoCambioGastos) : 1,
              tipo: a.tipo || "Taref",
              broker: a.brokers?.[0]?.name || "",
              idBroker: a.brokers?.[0]?._id || "",
            }
          // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_ARTICULOS_OC, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });


    axios
      .get(URL_CONCEPTOS_GASTOS_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.activo,
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.totalTarimas),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "ETA",
          "Observaciones",
          "Cantidad",
          "Tarimas",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    abrePDF(doc, `Embarques.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return {
          Activo: a.activo,
          Recibido: a.recibido,
          Numero: a.numero,
          FechaEmbarque: a.fechaEmbarque,
          Contenedor: a.contenedor,
          FechaEstimada: a.fechaEstimada,
          Observaciones: a.observaciones,
          Cantidad: a.totalCantidad,
          Cajas: a.totalCajas,
          Tarimas: a.totalTarimas,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoEmbarques";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoEmbarques",
        sheetFilter: [
          "Activo",
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "fechaEstimada",
          "Observaciones",
          "Cantidad",
          "Cajas",
          "Tarimas",
        ],
        sheetHeader: [
          "Activo",
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "fechaEstimada",
          "Observaciones",
          "Cantidad",
          "Cajas",
          "Tarimas",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.activo,
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.totalTarimas),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "ETA",
          "Observaciones",
          "Cantidad",
          "Tarimas",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Embarques",
          email: mailTo,
          fileName: "ListadoEmbarques.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Embarques.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // V23: PDF por contenedor simple, sin colores. Articulo, Cantidad, Cajas + 7 campos libres
  // W9: URL base derivada de URL_EMBARQUES (mismo /api/v1)
  const URL_ARCHIVOS_EMBARQUES = (process.env.REACT_APP_URL_EMBARQUES || "").replace(/embarques$/, "archivosEmbarques");

  async function abrirArchivos(embId, numero) {
    setArchivosEmbarqueId(embId);
    setArchivosEmbarqueNum(numero);
    try {
      const res = await axios.get(
        `${URL_ARCHIVOS_EMBARQUES}/embarque/${embId}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setArchivosEmbarque(res.data || []);
    } catch (e) {
      setArchivosEmbarque([]);
    }
    setArchivoNombre("");
    setArchivoUrl("");
    setArchivoFile(null);
    setPreviewArchivo(null);
    setModalArchivos(true);
  }

  async function eliminarArchivoEmbarque(arch) {
    if (!arch?._id) return;
    const ok = await Swal.fire({
      title: "Eliminar archivo",
      text: `¿Eliminar "${arch.nombre}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (!ok.isConfirmed) return;
    try {
      await axios.delete(`${URL_ARCHIVOS_EMBARQUES}/${arch._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      setArchivosEmbarque((prev) => prev.filter((x) => x._id !== arch._id));
      setPreviewArchivo(null);
      Swal.fire({ icon: "success", title: "Eliminado" });
    } catch (e) {
      Swal.fire({ icon: "error", title: "Error al eliminar" });
    }
  }

  async function subirArchivoEmbarque() {
    if (!archivoFile || !archivoNombre) {
      Swal.fire({ icon: "warning", title: "Captura nombre y archivo" });
      return;
    }
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      const fd = new FormData();
      fd.append("file", archivoFile);
      fd.append("id", archivosEmbarqueId);
      const up = await axios.post(process.env.REACT_APP_URL_UPMEDIA, fd, { headers });
      const url = up.data?.secure_url || up.data?.url || "";
      const created = await axios.post(
        URL_ARCHIVOS_EMBARQUES,
        {
          embarques: archivosEmbarqueId,
          nombre: archivoNombre,
          url,
          tipo: archivoFile.type?.includes("pdf") ? "PDF" : "IMG",
          fecha: new Date().toISOString().slice(0,10),
          user: user.id,
        },
        { headers }
      );
      setArchivosEmbarque([...archivosEmbarque, created.data]);
      setArchivoFile(null);
      setArchivoNombre("");
      setArchivoUrl("");
      Swal.fire({ icon: "success", title: "Subido", timer: 1100, showConfirmButton: false });
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error al subir" });
    }
  }

  async function PDFContenedorSimple(fechaEmbarque, contenedor, fechaEstimada, idPDFOC, numero) {
    await axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idPDFOC}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const all = response.data || [];
        const num2 = (n) =>
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(Number(n) || 0);

        let totalPiezas = 0, totalCajasPDF = 0, totalTarimasPDF = 0;
        const dataPDF = all.map((a) => {
          const art = a.articulos?.[0] || {};
          const cant = Number(a.cantidad || 0);
          const pxc = Number(art.piezasPorCaja || 0);
          const cxt = Number(art.cajasPorTarima || 0);
          const cajas = pxc > 0 ? cant / pxc : 0;
          // Sin "cajas por tarima" capturado no se puede saber cuántas
          // tarimas ocupa: se deja en blanco en vez de poner 0, que se leería
          // como "no ocupa ninguna".
          const tarimas = cxt > 0 ? cajas / cxt : null;
          totalPiezas += cant;
          totalCajasPDF += cajas;
          totalTarimasPDF += tarimas || 0;
          return [
            (art.codigo || "") + " " + (art.nombre || ""),
            new Intl.NumberFormat("en-US").format(cant),
            num2(cajas),
            tarimas === null ? "s/dato" : num2(tarimas),
            "", "", "", "", "", "",
          ];
        });
        const doc = new jsPDF("landscape", "mm", "a4", true);
        doc.text(`Contenedor # ${contenedor}`, 20, 20);
        doc.setFontSize(11);
        doc.text(`Fecha Embarque ${fechaEmbarque}`, 20, 27);
        doc.text(`ETA ${fechaEstimada}`, 20, 33);
        doc.autoTable({
          head: [["Articulo", "Cantidad", "Cajas", "Tarimas", "_", "_", "_", "_", "_", "_"]],
          body: dataPDF,
          foot: [[
            "TOTAL",
            new Intl.NumberFormat("en-US").format(totalPiezas),
            num2(totalCajasPDF),
            num2(totalTarimasPDF),
            "", "", "", "", "", "",
          ]],
          footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
          theme: "grid",
          startY: 40,
          styles: { fontSize: 8, lineColor: [0, 0, 0], lineWidth: 0.1 },
          headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
        });
        abrePDF(doc, `Contenedor-${contenedor || numero}.pdf`);
      })
      .catch((err) => console.log(err));
  }

  async function PDFOC(
    fechaEmbarque,
    contenedor,
    fechaEstimada,
    idPDFOC,
    numero
  ) {
    let totalCajas= 0
    await axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              proveedor: a.proveedores[0].nombre_comercial,
              articulo: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              OC: a.articulosOC.length > 0 ? a.articulosOC[0].ordenesCompra[0].idOrdenCompra : "NA",
              pzasXcaja: a.articulos[0].piezasPorCaja,
              cantidad: a.cantidad,
              cajas: parseFloat(a.cantidad) / parseFloat(a.articulos[0].piezasPorCaja),
              FOB: a.costo,
              total_costo: a.total_costo
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total_costo));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);

        // Sin permiso de costos el PDF detallado sale sin FOB ni Total
        const data = dataFinal.map((a) => {
          totalCajas = totalCajas + a.cajas
          return [
            a.proveedor,
            a.articulo,
            a.OC,
            new Intl.NumberFormat("en-US").format(a.pzasXcaja),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(a.cajas),
            ...(verCostos
              ? [
                  "$" + new Intl.NumberFormat("en-US").format(a.FOB),
                  "$" + new Intl.NumberFormat("en-US").format(a.total_costo),
                ]
              : []),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape", "mm", "a4", true);
        var img = new Image();
        
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 120, 10, 35, 18);
        doc.text(`Contenedor # ${contenedor}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha Embarque ${fechaEmbarque}`, 20, 25);
        doc.text(`ETA ${fechaEstimada}`, 20, 30);
        doc.autoTable({
          head: [["Proveedor", "Articulo", "OC", "Pzs Caja", "Cantidad", "Cajas", ...(verCostos ? ["FOB", "Total"] : [])]],
          body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
          startY: 45,
          foot: [
            [
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US").format(TC),
              new Intl.NumberFormat("en-US").format(totalCajas),
              ...(verCostos
                ? ["", "$" + new Intl.NumberFormat("en-US").format(TG)]
                : []),
            ],
          ],
          showFoot: "lastPage",
        });
        // abrePDF(doc, `Embarque-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function cancelarEmbarque(id, numero) {
    Swal.fire({
      title: "¿Cancelar embarque?",
      text: `Se revertirán todos los efectos (OC, NotaCxP, ArticulosEmbarques). Embarque #${numero}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${process.env.REACT_APP_URL_EMBARQUES.replace(/\/embarques$/, "")}/embarquesCancel/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Cancelado",
            text: "Embarque cancelado y revertido.",
            timer: 1500,
            showConfirmButton: false,
          });
          setTimeout(() => window.location.reload(), 1200);
        })
        .catch((err) => {
          const data = err?.response?.data;
          Swal.fire({
            icon: "error",
            title: "No se pudo cancelar",
            text: data?.message || "Error al cancelar el embarque",
          });
          console.log(data || err);
        });
    });
  }

  function jalaInfo(
    fechaEmbarque,
    fechaEstimada,
    observaciones,
    contenedor,
    numero,
    recibido,
    idEdit,
    noFactura,
    tipo
  ) {
    setFechaEmbarque(fechaEmbarque);
    setFechaEstimada(fechaEstimada);
    setObservaciones(observaciones);
    setContenedor(contenedor);
    setNumeroEmbarque(numero);
    setRecibidoEdit(recibido);
    setIdEdit(idEdit);
    setNoFactura(noFactura);
    setTipoEdit(tipo || "Taref");
    toggleEdit();
  }

  function editEmbarques(event) {
    event.preventDefault();
    const URL_EMBARQUES_EDIT = `${process.env.REACT_APP_URL_EMBARQUES}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_EMBARQUES_EDIT,
          {
            fechaEmbarque,
            fechaEstimada,
            observaciones,
            contenedor,
            noFactura,
            recibido: recibidoEdit,
            tipo: tipoEdit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Embarque",
            detalle: `${numeroEmbarque}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Recibido", field: "recibido", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Embarque", field: "fechaEmbarque", sortable: false },
    { name: "Broker", field: "broker", sortable: true },
    { name: "No Factura", field: "noFactura", sortable: false },
    { name: "Contenedor", field: "contenedor", sortable: true },
    { name: "ETA", field: "fechaEstimada", sortable: false },
    { name: "Cantidad", field: "totalCantidad", sortable: true },
    { name: "Cajas", field: "totalCajas", sortable: true },
    { name: "Tarimas", field: "totalTarimas", sortable: true },
    { name: "Tipo", field: "tipo", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.recibido.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.broker.toLowerCase().includes(search.toLowerCase()) ||
          comment.totalCantidad.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) => e.activo === activo);
    }
    if (recibido) {
      if (recibido === "Proximo") {
        // Próximos a recibir: no recibidos con ETA ≤ hoy+7 (incluye vencidos).
        // Los embarques cancelados (is_active "No") NO cuentan como pendientes.
        const limite = moment().add(7, "days").format("YYYY-MM-DD");
        computedComments = computedComments.filter(
          (e) =>
            e.activo !== "No" &&
            e.recibido !== "Si" &&
            e.fechaEstimada &&
            e.fechaEstimada <= limite
        );
      } else {
        computedComments = computedComments.filter((e) =>
          e.recibido.includes(recibido)
        );
      }
    }
    if (selectedTipo) {
      computedComments = computedComments.filter((e) => e.tipo === selectedTipo);
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "totalCantidad" &&
      sorting.field &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    recibido,
    activo,
    selectedTipo,
    selectedFechaInicio,
    selectedFechaFin,
  ]);


  const getNumero = (value, fallback = 0) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  };

  const getCantidadCosteo = (a) => {
    const cantidad = getNumero(a?.cantidad, 0);
    if (cantidad > 0) return cantidad;

    const pendiente = getNumero(a?.pendiente_recibir, 0);
    if (pendiente > 0) return pendiente;

    const recibidoArticulo = getNumero(a?.recibido, 0);
    if (recibidoArticulo > 0) return recibidoArticulo;

    const cantidadOriginal = getNumero(a?.cantidadOriginal, 0);
    if (cantidadOriginal > 0) return cantidadOriginal;

    return 0;
  };


  function EditArticulosKasher(
    idOC,
    totalCantidad,
    total_costo,
    tipoCambioEmbarque,
    total_gasto,
    costeado,
    tipo,
    ivaPct
  ) {
    const tc = getNumero(tipoCambioEmbarque, 0);
    const gastoTotal = getNumero(total_gasto, 0);

    setIdEdit(idOC);
    setTotalCantidadEdit(totalCantidad);
    setTotalGeneralEdit(total_costo);
    setTipoCambio(tc);
    // Los gastos se capturan en PESOS: su TC es 1. Antes se ponía el TC del
    // contenedor por default y, si se costeaba así, los gastos salían ×18.
    setTipoCambioGastos(comments.find((c) => c._id === idOC)?.tipoCambioGastos || 1);
    setTotalGastoPrecosteo(gastoTotal);
    setCosteadoEdit(costeado || "No");
    setTipoEmbarque(tipo || "Taref");
    setIvaPorcentaje(ivaPct == null || ivaPct === "" ? 16 : Number(ivaPct));

    axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const allArticulosPedido = response.data || [];

        const arrayTabla = allArticulosPedido
          .map((a) => {
            const cantidadCosteo = getCantidadCosteo(a);
            const costoFOB = getNumero(a?.costoUSD ?? a?.costo, 0);

            return {
              id: a?._id,
              idArticulos: a?.articulos?.[0]?._id || a?.articulos?.[0] || "",
              articulo:
                (a?.articulos?.[0]?.codigo || a?.articulos?.[0]?.SKU || "") +
                " " +
                (a?.articulos?.[0]?.nombre || ""),
              cantidad: cantidadCosteo,
              cantidadOriginal: getNumero(a?.cantidad, 0),
              recibido: getNumero(a?.recibido, 0),
              pendiente_recibir: getNumero(a?.pendiente_recibir, 0),
              costoUSD: costoFOB,
              total: cantidadCosteo * costoFOB,
              CBM: getNumero(a?.CBM, 0),
              comisionVendedorPorcentaje: getNumero(a?.comisionVendedorPorcentaje, 0),
              comisionVendedorCantidad: getNumero(a?.comisionVendedorCantidad, 0),
              igiPorcentaje: getNumero(
                a?.articulos?.[0]?.aranceles ?? a?.igiPorcentaje ?? 0,
                0
              ),
              // Un TC de 1 en un embarque en dólares es un error de captura
              // (embarque 4): se propone el del contenedor, igual que el back.
              tipoCambioUSDMXN:
                Number(a?.tipoCambioUSDMXN) > 1.5 || tc <= 1.5
                  ? Number(a?.tipoCambioUSDMXN) || tc
                  : tc,
            };
          })
          .filter((el) => el && el.id);

        const conGastos = recalcularGastosPorFOB(arrayTabla, gastoTotal);
        setArticulosPedido(conGastos);
        toggleEditFOBKasher();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar los artículos del embarque",
          footer:
            err?.response?.data?.message ||
            JSON.stringify(err?.response?.data || err.message),
        });
      });
  }

  const handleCostoChange = (index, value) => {
    const nuevosArticulos = [...articulosPedido];

    nuevosArticulos[index] = {
      ...nuevosArticulos[index],
      costoUSD: Number(value) || 0,
    };

    const conGastos = recalcularGastosPorFOB(
      nuevosArticulos,
      totalGastoPrecosteo
    );

    setArticulosPedido(conGastos);
  };


  const handleCBMChange = (index, value) => {
    const nuevos = [...articulosPedido];
    nuevos[index] = {
      ...nuevos[index],
      CBM: Number(value) || 0,
    };
    setArticulosPedido(nuevos);
  };

  const handleIgiChange = (index, value) => {
    const nuevos = [...articulosPedido];
    nuevos[index] = {
      ...nuevos[index],
      igiPorcentaje: Number(value) || 0,
    };
    setArticulosPedido(nuevos);
  };

  const handleTCArticuloChange = (index, value) => {
    const nuevos = [...articulosPedido];
    nuevos[index] = {
      ...nuevos[index],
      tipoCambioUSDMXN: Number(value) || 0,
    };
    setArticulosPedido(nuevos);
  };

  const handleComisionChange = (index, value) => {
    const nuevosArticulos = [...articulosPedido];
    const porcentaje = parseFloat(value) || 0;
    const fob = parseFloat(nuevosArticulos[index].costoUSD) || 0;

    nuevosArticulos[index].comisionVendedorPorcentaje = porcentaje;
    nuevosArticulos[index].comisionVendedorCantidad = (fob * porcentaje) / 100;

    setArticulosPedido(nuevosArticulos);
  };

const recalcularGastosPorFOB = (items, totalGasto) => {
  if (!items || !items.length) return items;

  const gastoTotal = Number(totalGasto) || 0;

  const totalFOBEmbarque = items.reduce((acc, a) => {
    const cantidad = Number(a.cantidad) || 0;
    const costoFOB = Number(a.costoUSD) || 0;

    return acc + cantidad * costoFOB;
  }, 0);

  if (!totalFOBEmbarque) {
    return items.map((a) => ({
      ...a,
      porcentajeFOB: 0,
      gastoTotalArticulo: 0,
      gastos: 0,
    }));
  }

  return items.map((a) => {
    const cantidad = Number(a.cantidad) || 0;
    const costoFOB = Number(a.costoUSD) || 0;

    const totalFOBArticulo = cantidad * costoFOB;
    const porcentajeFOB = totalFOBArticulo / totalFOBEmbarque;
    const gastoTotalArticulo = gastoTotal * porcentajeFOB;
    const gastoPorPieza = cantidad > 0 ? gastoTotalArticulo / cantidad : 0;

    return {
      ...a,
      totalFOBArticulo: Number(totalFOBArticulo.toFixed(2)),
      porcentajeFOB: Number(porcentajeFOB.toFixed(6)),
      gastoTotalArticulo: Number(gastoTotalArticulo.toFixed(2)),
      gastos: Number(gastoPorPieza.toFixed(2)),
    };
  });
};

  const calcularCosteoKasher = (a) => {
    const cantidad = getCantidadCosteo(a);
    const costoFOB = getNumero(a?.costoUSD, 0);
    // gastos por pieza en "moneda original" del total_gasto; lo convertimos a pesos via tipoCambioGastos
    const gastosOriginales = getNumero(a?.gastos, 0);
    const tcGastos = Number(tipoCambioGastos) > 0 ? Number(tipoCambioGastos) : 1;
    const gastos = gastosOriginales * tcGastos;
    const igiPorcentaje = getNumero(a?.igiPorcentaje ?? 15, 15);
    const comisionUSD = getNumero(a?.comisionVendedorCantidad, 0);

    // TC por articulo (fallback al TC del embarque)
    const tcArticulo = Number(a?.tipoCambioUSDMXN) > 0
      ? Number(a.tipoCambioUSDMXN)
      : tipoCambio;

    const totalFOB = cantidad * costoFOB;
    const declaradoPesos = totalFOB * tcArticulo;

    // Impuestos (IGI + IVA) SOLO aplican cuando el embarque es Kasher.
    // Los Taref se importan por otro régimen y no llevan estos impuestos.
    const esKasher = tipoEmbarque === "Kasher";
    const igi = esKasher ? declaradoPesos * (igiPorcentaje / 100) : 0;
    const baseIVA = esKasher ? declaradoPesos + igi : 0;
    const iva = esKasher ? baseIVA * (getNumero(ivaPorcentaje, 16) / 100) : 0;
    const impuestos = igi + iva;
    const impuestosUnitarios = cantidad > 0 ? impuestos / cantidad : 0;

    const fobUnitarioPesos = costoFOB * tcArticulo;
    const comisionPesos = comisionUSD * tcArticulo;

    const costoUnitario =
      fobUnitarioPesos +
      comisionPesos +
      gastos +
      impuestosUnitarios;

    return {
      cantidad,
      costoFOB,
      gastos,
      igiPorcentaje,
      comisionUSD,
      totalFOB,
      declaradoPesos,
      igi,
      baseIVA,
      iva,
      impuestos,
      impuestosUnitarios,
      fobUnitarioPesos,
      comisionPesos,
      costoUnitario,
      costoMX: Number(costoUnitario.toFixed(2)),
    };
  };


  const saveFOBEmbarque = async (event) => {
    event.preventDefault();

    // Para eso sirve la marca de "gastos validados": si el embarque se costea
    // con gastos incompletos, el costo sale por debajo del real y luego es
    // difícil de detectar. Se avisa, pero no se bloquea: a veces se costea a
    // propósito con lo que hay.
    const embActual = comments.find((c) => c._id === idEdit);
    if (embActual && embActual.gastosValidados !== "Si") {
      const r = await Swal.fire({
        icon: "warning",
        title: "Los gastos no están validados",
        text:
          "Este embarque no tiene marcados los gastos como completos. Si falta alguno, el costo va a salir por debajo del real.",
        showCancelButton: true,
        confirmButtonText: "Costear de todos modos",
        cancelButtonText: "Revisar los gastos",
        confirmButtonColor: "#dc3545",
      });
      if (!r.isConfirmed) return;
    }

    toggleProgreso();

    try {
      // 1) Persistir TC por articulo capturado en el modal
      await Promise.all(
        (articulosPedido || []).map((a) =>
          axios.patch(
            `${URL_ARTICULOS_EMBARQUES}EditTC/${a.id}`,
            {
              tipoCambioUSDMXN: Number(a.tipoCambioUSDMXN) > 0
                ? Number(a.tipoCambioUSDMXN)
                : Number(tipoCambio) || 0,
              igiPorcentaje: Number(a.igiPorcentaje) || 0,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        )
      );

      // 2) Costear (el back lee TC por articulo de cada ArticulosEmbarques)
      const respCosteo = await axios.patch(
        `${URL_EMBARQUES}/costear/${idEdit}`,
        {
          tipoCambioGastos: Number(tipoCambioGastos) > 0
            ? Number(tipoCambioGastos)
            : Number(tipoCambio) || 1,
          // El % de IVA se guarda en el embarque y el back lo usa al costear
          ivaPorcentaje: Number(ivaPorcentaje) || 0,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Costeo Kasher Embarque",
          detalle: `${idEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      toggleEditFOBKasher();
      setModalProgreso(false);
      await avisaRecosteo(respCosteo?.data?.resumen, "Embarque costeado");
      window.location.reload();
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al guardar el costeo",
        footer:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          JSON.stringify(error?.response?.data || error.message),
      });
    }

    setModalProgreso(false);
  };


  const AUTH = () => ({
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  });

  // Aviso de lo que movió un recosteo: costo de los artículos y de lo vendido
  const avisaRecosteo = (resumen, titulo) => {
    const a = resumen?.articulos?.totales;
    const money = (n) =>
      new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n) || 0);
    return Swal.fire({
      icon: "success",
      title: titulo,
      html: a
        ? `Se recalculó el costo de <b>${a.articulos}</b> artículos y de <b>${a.lineasCambiadas}</b> renglones ya vendidos.<br/>` +
          `Costo de lo vendido: ${money(a.costoVendidoAntes)} → <b>${money(a.costoVendidoDespues)}</b>`
        : resumen
        ? "Se actualizó el costo aterrizado del embarque."
        : "",
    });
  };

  // ── Resumen del costeo: gastos por concepto y su prorrateo por artículo
  const [modalResumen, setModalResumen] = useState(false);
  const [resumenCosteo, setResumenCosteo] = useState(null);
  const [editandoPrecios, setEditandoPrecios] = useState(false);
  const [preciosEdit, setPreciosEdit] = useState({});
  const [motivoPrecios, setMotivoPrecios] = useState("");
  const [guardandoResumen, setGuardandoResumen] = useState(false);

  async function abrirResumenCosteo(id) {
    setResumenCosteo(null);
    setEditandoPrecios(false);
    setPreciosEdit({});
    setMotivoPrecios("");
    setModalResumen(true);
    try {
      const r = await axios.get(`${URL_EMBARQUES}ResumenCosteo/${id}`, AUTH());
      setResumenCosteo(r.data);
    } catch (error) {
      setModalResumen(false);
      Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || error.message });
    }
  }

  async function recostearDesdeResumen() {
    const id = resumenCosteo?.embarque?._id;
    if (!id) return;
    setGuardandoResumen(true);
    try {
      const r = await axios.patch(`${URL_EMBARQUES}Recostear/${id}`, {}, AUTH());
      await avisaRecosteo(r.data, "Costos recalculados");
      await abrirResumenCosteo(id);
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo recostear", text: error?.response?.data?.message || error.message });
    } finally {
      setGuardandoResumen(false);
    }
  }

  // Lo que cambia en cada nota del proveedor con los precios capturados
  const difPreciosPorNota = useMemo(() => {
    const out = {};
    (resumenCosteo?.renglones || []).forEach((r) => {
      const v = preciosEdit[r._id];
      if (v === undefined || v === "") return;
      const dif = (Number(v) - Number(r.costoFOB)) * Number(r.cantidad);
      if (Math.abs(dif) < 0.005) return;
      out[r.notaCxP] = (out[r.notaCxP] || 0) + dif;
    });
    return out;
  }, [resumenCosteo, preciosEdit]);

  async function guardarPrecios() {
    const id = resumenCosteo?.embarque?._id;
    const renglones = (resumenCosteo?.renglones || [])
      .filter((r) => preciosEdit[r._id] !== undefined && preciosEdit[r._id] !== "")
      .filter((r) => Math.abs(Number(preciosEdit[r._id]) - Number(r.costoFOB)) > 0.000001)
      .map((r) => ({ id: r._id, costoUSD: Number(preciosEdit[r._id]) }));
    if (!renglones.length) {
      return Swal.fire({ icon: "info", title: "No cambiaste ningún precio" });
    }
    const conf = await Swal.fire({
      icon: "warning",
      title: "Cambiar precios del proveedor",
      text: `Se cambian ${renglones.length} precios. Se ajusta lo que se le debe al proveedor y se recalcula el costo.`,
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    });
    if (!conf.isConfirmed) return;
    setGuardandoResumen(true);
    try {
      const r = await axios.patch(`${URL_EMBARQUES}EditPrecios/${id}`, { renglones, motivo: motivoPrecios }, AUTH());
      await avisaRecosteo(r.data?.recosteo, "Precios actualizados");
      window.location.reload();
    } catch (error) {
      const d = error?.response?.data;
      Swal.fire({
        icon: "error",
        title: d?.message || "No se pudieron cambiar los precios",
        html: (d?.excedidas || [])
          .map((n) => `Nota ${n.idNotasCxP}: saldo ${n.saldo.toFixed(2)} USD, la baja sería de ${n.baja.toFixed(2)} USD`)
          .join("<br/>"),
      });
    } finally {
      setGuardandoResumen(false);
    }
  }

  function excelResumen() {
    const r = resumenCosteo;
    if (!r) return;
    const filas = r.renglones.map((x) => ({
      Articulo: x.codigo,
      Descripcion: x.nombre,
      Proveedor: x.proveedor,
      Piezas: x.cantidad,
      FOBUSD: x.costoFOB,
      TC: x.tipoCambio,
      FOBTotalUSD: Number(x.totalFOB.toFixed(2)),
      PorcentajeFOB: Number((x.porcentajeFOB * 100).toFixed(4)),
      GastoAsignado: Number(x.gastoTotalArticulo.toFixed(2)),
      GastoPorPieza: Number(x.gastos.toFixed(2)),
      ImpuestosPorPieza: x.cantidad > 0 ? Number((x.impuestos / x.cantidad).toFixed(2)) : 0,
      CostoUnitario: x.costoUnitario,
    }));
    const gastos = r.gastos.conceptos.map((g) => ({ Concepto: g.concepto, Estimado: g.estimado, Real: g.real }));
    new ExportJsonExcel({
      fileName: `CosteoEmbarque-${r.embarque.idEmbarques}`,
      datas: [
        {
          sheetData: gastos,
          sheetName: "Gastos",
          sheetFilter: ["Concepto", "Estimado", "Real"],
          sheetHeader: ["Concepto", "Estimado", "Real"],
        },
        {
          sheetData: filas,
          sheetName: "Prorrateo",
          sheetFilter: Object.keys(filas[0] || {}),
          sheetHeader: ["Artículo", "Descripción", "Proveedor", "Piezas", "FOB USD", "TC", "FOB total USD", "% FOB",
            "Gasto asignado", "Gasto por pieza", "Impuestos por pieza", "Costo unitario"],
        },
      ],
    }).saveExcel();
  }

  function EditGastos(id) {
    // La nota general vive en el embarque; se toma del renglón ya cargado
    // en la tabla para no hacer otra consulta.
    const emb = comments.find((c) => c._id === id);
    setObservacionesGastos(emb?.observacionesGastos || "");
    setGastosValidados(emb?.gastosValidados || "No");

    axios
      .get(`${URL_GASTOS_EMBARQUES}Embarque/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGastosEmbarque = res.data;
        setGastosEmbarque(allGastosEmbarque);
        console.log(allGastosEmbarque);
      })
      .catch((err) => {
        console.log(err);
      });

    setInputFieldsGastos([
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
      },
    ]);
    setIdEdit(id);

    toggleEditGastos();
  }

  const handleRemoveFieldsGastos = (id) => {
    const values = [...inputFieldsGastos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsGastos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadGastos(TC);
  };

  const handleAddFieldsGastos = () => {
    setInputFieldsGastos([
      ...inputFieldsGastos,
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
      },
    ]);
  };

  const handleChangeInputGastos = (id, event) => {
    const newInputFieldsGastos = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGastos);
  };

  const handleChangeInputGastosExistentes = (id, event) => {
    const newGastosEmbarque = gastosEmbarque.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setGastosEmbarque(newGastosEmbarque);
  };

  function BuscaGasto(id, event) {
    if (
      inputFieldsGastos.filter((e) => e.concepto == event.target.value).length >
      0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El gasto ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFieldsGastos = inputFieldsGastos.map((i) => {
        if (id === i.id) {
          i.concepto = "";
        }
        return i;
      });
      setInputFieldsGastos(newInputFieldsGastos);
    } else {
      conceptosGastos.map((a) => {
        if (a._id == event.target.value) {
          let concepto = a._id;
          let estimado = a.estimado;
          handleChangeInputGasto(id, concepto, estimado);
        }
      });
    }
  }
  const handleChangeInputGasto = (id, concepto, estimado) => {
    const newInputFieldsGasto = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i.concepto = concepto;
        i.estimado = estimado;
        i.real = estimado;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGasto);
  };

  const saveGastosEmbarque = async (event) => {
    event.preventDefault();

    // Validación: antes de guardar se revisa que los gastos estén completos.
    // Sin esto se costea un embarque con gastos a medias y el costo sale bajo,
    // que es difícil de notar después.
    const nuevos = inputFieldsGastos.filter((a) => a.concepto !== "");
    const todos = [
      ...gastosEmbarque.map((a) => ({
        concepto: a.conceptosGastosEmbarques?.[0]?.concepto || "",
        estimado: Number(a.estimado || 0),
        real: Number(a.real || 0),
      })),
      ...nuevos.map((a) => ({
        concepto:
          conceptosGastos.find((c) => c._id === a.concepto)?.concepto || "Nuevo",
        estimado: Number(a.estimado || 0),
        real: Number(a.real || 0),
      })),
    ];

    if (!todos.length) {
      return Swal.fire({
        icon: "error",
        title: "No hay gastos",
        text: "Captura al menos un concepto antes de guardar.",
      });
    }

    const sinReal = todos.filter((a) => a.real <= 0);
    const totalEstimado = todos.reduce((t, a) => t + a.estimado, 0);
    const totalReal = todos.reduce((t, a) => t + a.real, 0);

    if (sinReal.length) {
      const r = await Swal.fire({
        icon: "warning",
        title: "Faltan importes reales",
        html:
          `<b>${sinReal.length} de ${todos.length}</b> conceptos no tienen importe real:<br/><br/>` +
          sinReal.map((a) => a.concepto).join("<br/>") +
          "<br/><br/>Si costeas el embarque así, el costo va a salir por debajo del real.",
        showCancelButton: true,
        confirmButtonText: "Guardar de todos modos",
        cancelButtonText: "Volver a capturar",
        confirmButtonColor: "#dc3545",
      });
      if (!r.isConfirmed) return;
    }

    setValidaBoton(false);
    toggleProgreso();

    try {
      // La nota general se guarda en el embarque, no en cada concepto
      await axios.patch(
        `${URL_EMBARQUES}/${idEdit}`,
        {
          observacionesGastos: observacionesGastos || "NA",
          gastosValidados,
          gastosValidadosFecha:
            gastosValidados === "Si" ? moment().format("YYYY-MM-DD") : "",
        },
        AUTH()
      );
      // Antes cada gasto se mandaba suelto y el aviso salía con el primero que
      // terminaba; ahora se espera a que se guarden todos.
      await Promise.all([
        ...nuevos.map((a) =>
          axios.post(
            URL_GASTOS_EMBARQUES,
            { conceptosGastosEmbarques: a.concepto, estimado: a.estimado, real: a.real, embarques: idEdit },
            AUTH()
          )
        ),
        ...gastosEmbarque.map((a) =>
          axios.patch(`${URL_GASTOS_EMBARQUES}/${a._id}`, { estimado: a.estimado, real: a.real }, AUTH())
        ),
      ]);
      await axios.post(URL_LOGS, { tipo: "Editar Gastos Embarque", detalle: `${idEdit}`, user: user.id }, AUTH());

      // Si el embarque ya está costeado, los gastos nuevos tienen que llegar al
      // costo de sus artículos y de lo que ya se vendió: se recostea.
      const emb = comments.find((c) => c._id === idEdit);
      let resumen = null;
      if (emb?.costeado === "Si") {
        const r = await axios.patch(`${URL_EMBARQUES}Recostear/${idEdit}`, {}, AUTH());
        resumen = r.data;
      }
      setModalProgreso(false);
      await avisaRecosteo(resumen, "Gastos guardados");
      window.location.reload();
    } catch (error) {
      console.log(error);
      setModalProgreso(false);
      setValidaBoton(true);
      Swal.fire({
        icon: "error",
        title: "No se pudieron guardar los gastos",
        text: error?.response?.data?.message || error.message,
      });
    }
  };

  // function EditArticulos(idOC, contenedor, idProveedor, idContenedor) {
  //   setInputFields([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       cantidadAnterior: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: "",
  //       notasCxP: "",
  //     },
  //   ]);
  //   setInputFieldsNuevos([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: idProveedor,
  //       ordenCompra: ""
  //     },
  //   ]);
  //   setIdArtEdit(idOC);
  //   setContenedorEdit(contenedor);
  //   setIdProveedor(idProveedor);
  //   setIdContenedor(idContenedor);
  //   setIdNotaCxP("");
  //   axios
  //     .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulosOrden: a.articulosOC[0]._id,
  //             articulos: a.articulos[0]._id,
  //             cantidad: a.cantidad,
  //             cantidadAnterior: a.cantidad,
  //             piezasPorCaja: a.articulos[0].piezasPorCaja,
  //             cajas:
  //               parseFloat(a.cantidad) /
  //               parseFloat(a.articulos[0].piezasPorCaja),
  //             cantidadOC: a.articulosOC[0].cantidad,
  //             costo: a.costo,
  //             costoTotal: a.total_costo,
  //             proveedorOrden: a.proveedores[0]._id,
  //             notasCxP: a.notasCxP[0]._id,
  //             costoNotasCxP: a.notasCxP[0].total_costo,
  //             saldoNotasCxP: a.notasCxP[0].saldo,
  //             ordenCompra: a.articulosOC[0].ordenesCompra[0]._id,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });
  //       let dataFinal = Object.values(arrayTabla);
  //       setArticulosOrden(dataFinal);
  //       let cant = dataFinal.map((c) => parseFloat(c.cantidad));
  //       let TC = cant.reduce((t, total, index) => t + total, 0);
  //       setTotalCantidadEdit(TC);
  //       let importes = dataFinal.map((c) => parseFloat(c.total));
  //       let TG = importes.reduce((t, total, index) => t + total, 0);
  //       setTotalGeneralEdit(TG);

  //       let nota = dataFinal.map((c) => c.notasCxP);
  //       // let nota = dataFinal.map((c) => c.notasCxP);
  //       // let notaTT = nota[0].reduce((t, total, index) => t + total, 0);
  //       setIdNotaCxP(nota[0]);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   toggleEditArticulos();
  // }

  function ActualizaTotales() {
    let cant = articulosOrden.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);

    let cantNu = inputFieldsNuevos.map((c) => parseFloat(c.cantidad));
    let TCNu = cantNu.reduce((t, total, index) => t + total, 0);

    setTotalCantidadEdit(TC + TCNu);

    let agrupado = articulosOrden.reduce(function (groups, item) {
      const val = item["notasCxP"];
      groups[val] = groups[val] || {
        notasCxP: item.notasCxP,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      groups[val].notasCxP = item.notasCxP;
      groups[val].saldoNotasCxP = item.saldoNotasCxP;
      groups[val].costoNotasCxP = item.costoNotasCxP;
      return groups;
    }, []);
    let temp = Object.values(agrupado);

    // let agrupadoNuevo = inputFieldsNuevos.reduce(function (groups, item) {
    //   const val = item["notasCxP"];
    //   groups[val] = groups[val] || {
    //     notasCxP: item.notasCxP,
    //     costoTotal: 0,
    //     cantidad: 0,
    //   };
    //   groups[val].proveedorOrden = item.proveedorOrden;
    //   groups[val].costoTotal += item.costoTotal;
    //   groups[val].cantidad += item.cantidad;
    //   groups[val].notasCxP = item.notasCxP;
    //   groups[val].saldoNotasCxP = item.saldoNotasCxP;
    //   groups[val].costoNotasCxP = item.costoNotasCxP;
    //   return groups;
    // }, []);
    // let temp = Object.values(agrupado);
    setAgrupado(temp);
  }

  const handleChangeInputCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const saveEditArt = async (event) => {
    event.preventDefault();

    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = articulosOrden.length + articulosOrden.length + agrupado.length + inputFieldsNuevos.length + inputFieldsNuevos.length
    let TCosto = articulosOrden.map((c) => parseFloat(c.costoTotal));
    let TTC = TCosto.reduce((t, total, index) => t + total, 0);

    let TCostoNuevo = inputFieldsNuevos.map((c) => parseFloat(c.costoTotal));
    let TTCNu = TCostoNuevo.reduce((t, total, index) => t + total, 0);

    let TCantNuevo = inputFieldsNuevos.map((c) => parseFloat(c.cantidad));
    let TTCantNu = TCantNuevo.reduce((t, total, index) => t + total, 0);

    let totalTotal = TTC + TTCNu
    try {
      await axios
        .patch(
          `${URL_EMBARQUES}/${idArtEdit}`,
          {
            total_cantidad: totalCantidadEdit,
            total_costo: parseFloat(totalTotal).toFixed(2),
            saldo: parseFloat(totalTotal).toFixed(2),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          agrupado.map((b) => {
            axios
              .patch(
                `${URL_NOTAS_CXP}editEmbarque/${idNotaCxP}`,
                {
                  proveedores: b.proveedorOrden,
                  total_cantidad: b.cantidad + TTCantNu,
                  total_costo: parseFloat(totalTotal).toFixed(2),
                  saldo:
                    parseFloat(b.saldoNotasCxP) -
                    parseFloat(b.costoNotasCxP) +
                    parseFloat(b.costoTotal) +
                    parseFloat(TTCNu),
                  difSaldo:
                    parseFloat(b.costoTotal + TTCNu) - parseFloat(b.costoNotasCxP),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });

            // Acaba el primer map
          });

          articulosOrden.map((j) => {
            axios
              .patch(
                `${URL_ARTICULOS_EMBARQUES}EditCant/${j.id}`,
                {
                  cantidad: j.cantidad - j.cantidadAnterior,
                  total_costo: j.costoTotal,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          articulosOrden.map((w) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}editEmbarcadoCant/${w.articulosOrden}`,
                {
                  embarcado: w.cantidad - w.cantidadAnterior,
                  ordenesCompra: w.ordenCompra
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          // Acaba el segundo map
        })
        // Catch primer then
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });

        // Articulos Nuevos
        inputFieldsNuevos.map((a) => {
          if (
            a.articulos != "" &&
            a.cantidad != 0 
          ) {
            axios
              .post(
                `${URL_ARTICULOS_EMBARQUES}`,
                {
                  articulosOC: a.articulosOrden,
                  articulos: a.articulos,
                  cantidad: a.cantidad,
                  recibido: 0,
                  pendiente_recibir: a.cantidad,
                  embarques: idArtEdit,
                  notasCxP: idNotaCxP,
                  costo: a.costo,
                  total_costo: a.costoTotal,
                  proveedores: idProveedor,
                  faltante: 0,
                  danado: 0,
                  impuestos: 0,
                  revisarFaltante: 10,
                  revisarDanado: 10,
                  pedirFaltante: 0,
                  pedirDanado: 10,
                  faltanteTotal: 0,
                  danadoTotal: 0,
                  descuentoFaltante: 0,
                  descuentoDanado: 0,
                  descuentoTotal: 0,
                  familias: "NA",
                  sup: "NA",
                  observaciones:"NA",
                  calidad:"No"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });

        inputFieldsNuevos.map((w) => {
          if (
            w.articulos != "" &&
            w.cantidad != 0 
          ) {
          axios
            .patch(
              `${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
              {
                embarcado: w.cantidad,
                ordenesCompra: w.ordenCompra
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )
            .then(() => {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Embarque",
                      detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });


    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  function BuscaArticulo(id, event) {
    if (
      inputFieldsNuevos.filter((e) => e.articulosOrden == event.target.value).length >
      0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
        if (id === i.id) {
          i.articulos = "";
        }
        return i;
      });
      setInputFieldsNuevos(newInputFieldsNuevos);
    } else {
      articulos.map((a) => {
        if (a._id == event.target.value) {
          let articulos = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          handleChangeInputArticulo(id, articulos, piezasPorCaja);
        }
      });
    }
  }

  const handleChangeInputArticulo = (id, articulos, piezasPorCaja) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulos = articulos;
        i.piezasPorCaja = piezasPorCaja;
        i.cantidadOC = 0;
        i.articulosOrden = "";
        // i.cantidad= 0
        i.cajas = 0;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
  };

  function BuscaOrden(id, event) {
    articulosOC.map((a) => {
      if (a._id == event.target.value) {
        let articulosOrden = a._id;
        let cantidadOC = a.cantidad;
        let costo = a.precio
        let ordenCompra = a.ordenesCompra[0]._id
        handleChangeInputOC(id, articulosOrden, cantidadOC, costo, ordenCompra);
      }
    });
  }
  const handleChangeInputOC = (id, articulosOrden, cantidadOC, costo, ordenCompra) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoTotal = parseFloat(costo) * parseFloat(i.cantidad);
        i.ordenCompra = ordenCompra;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };
  const handleChangeInputCantidadNuevos = (id, event) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajasNuevos = (id, event) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };

    const handleAddFields = () => {
    let TC = totalCaptura + 1;
    const ultimo = inputFieldsNuevos[inputFieldsNuevos.length - 1];

    setTotalCaptura(TC);
    setInputFieldsNuevos([
      ...inputFieldsNuevos,
      {
        id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoTotal: 0,
        proveedorOrden: idProveedor,
        ordenCompra: "",
        CBM: 0,
        costoUSD: 0,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,
        igiPorcentaje: 15,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFieldsNuevos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsNuevos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = values.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  };

  function EditTC(idEmbarque, tcEmbarque) {
    setIdEmbarqueTC(idEmbarque);
    axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idEmbarque}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const data = (res.data || []).map((a) => {
          const cantPropia = Number(a?.cantidad || 0);
          const recibido = Number(a?.recibido || 0);
          const pendRec = Number(a?.pendiente_recibir || 0);
          const cantOC = Number(a?.articulosOC?.[0]?.cantidad || 0);
          // Fallback: si la cantidad del AE quedo en 0, derivar de recibido + pendiente, o de la OC
          const cantidad =
            cantPropia > 0
              ? cantPropia
              : recibido + pendRec > 0
              ? recibido + pendRec
              : cantOC;
          return {
            id: a?._id,
            articulo:
              (a?.articulos?.[0]?.codigo || "") +
              " " +
              (a?.articulos?.[0]?.nombre || ""),
            cantidad,
            recibido,
            pendiente_recibir: pendRec,
            tipoCambioUSDMXN:
              Number(a?.tipoCambioUSDMXN) > 1.5 || Number(tcEmbarque || 0) <= 1.5
                ? Number(a?.tipoCambioUSDMXN) || Number(tcEmbarque || 0)
                : Number(tcEmbarque || 0),
          };
        });
        setArticulosEmbTC(data);
        toggleEditTC();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar los artículos del embarque",
        });
      });
  }

  const handleTCChange = (index, value) => {
    const nuevos = [...articulosEmbTC];
    nuevos[index] = { ...nuevos[index], tipoCambioUSDMXN: Number(value) || 0 };
    setArticulosEmbTC(nuevos);
  };

  const saveTC = async () => {
    try {
      await Promise.all(
        articulosEmbTC.map((a) =>
          axios.patch(
            `${URL_ARTICULOS_EMBARQUES}EditTC/${a.id}`,
            { tipoCambioUSDMXN: Number(a.tipoCambioUSDMXN) || 0 },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        )
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar TC Articulos Embarque",
          detalle: `${idEmbarqueTC}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      toggleEditTC();
      // El TC es parte del costo aterrizado: si ya está costeado, recostear
      let resumen = null;
      if (comments.find((c) => c._id === idEmbarqueTC)?.costeado === "Si") {
        const r = await axios.patch(`${URL_EMBARQUES}Recostear/${idEmbarqueTC}`, {}, AUTH());
        resumen = r.data;
      }
      await avisaRecosteo(resumen, "Tipos de cambio actualizados");
      window.location.reload();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo guardar el TC",
        footer:
          error?.response?.data?.message ||
          JSON.stringify(error?.response?.data || error.message),
      });
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {puedeVer ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.embarques ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/EmbarquesCreate"
                >
                  Nuevo Embarque
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Embarque
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={
                    e=>{
                      axios
                      .get(`${URL_INVENTARIOS}Desarrollo`, {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      })
                      .then((response) => {
                        alert(response.data)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    }
                  }
                >
                  Desarrollo <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Embarque</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Embarques</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="Si">Activos</option>
                <option value="">Todos</option>
                <option value="No">Cancelados</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Recibido</Label>
              <Input
                bsSize="sm"
                type="select"
                value={recibido}
                required
                onChange={(e) => {
                  setRecibido(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Recibidos</option>
                <option value="No">No Recibidos</option>
                <option value="Proximo">Próximos a recibir (ETA ≤ +7d)</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Tipo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedTipo}
                onChange={(e) => {
                  setSelectedTipo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Taref">Taref</option>
                <option value="Kasher">Kasher</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                          style={
                            a.activo == "No"
                              ? { backgroundColor: "#d6d8db", color: "#6c757d" }
                              : a.recibido == "Si"
                              ? { backgroundColor: "#64e379" }
                              : a.recibido == "No" && (a.fechaEstimada < hoy)?{ backgroundColor: "red" }
                              : null
                          }
                        >
                      <td>{a.activo}</td>
                      <td>{a.recibido}</td>
                      <td>{a.numero}</td>
                      <td>{fDMA(a.fechaEmbarque)}</td>
                      <td>{a.broker}</td>
                      <td>{a.noFactura}</td>
                      <td>{a.contenedor}</td>
                      <td>{fDMA(a.fechaEstimada)}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.totalCajas)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.totalTarimas)}
                        {/* Si hay artículos sin cajasPorTarima capturado, el
                            número está incompleto y hay que decirlo. */}
                        {a.articulosSinTarima > 0 ? (
                          <span
                            style={{ color: "#b8860b", fontWeight: 600, marginLeft: 4 }}
                            title={`${a.articulosSinTarima} artículos sin "cajas por tarima" capturado`}
                          >
                            *
                          </span>
                        ) : null}
                      </td>
                      <td>{a.tipo}</td>
                      <td>
                        {/* Embarque cancelado (is_active "No"): sin acciones */}
                        {a.activo === "No" ? (
                          <span style={{ fontWeight: "bold" }}>Cancelado</span>
                        ) : puedeAcciones ? (
                          <div>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              title="PDF detallado"
                              onClick={(e) =>
                                PDFOC(
                                  a.fechaEmbarque,
                                  a.contenedor,
                                  a.fechaEstimada,
                                  a._id,
                                  a.numero
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            {/* El PDF de conteo por contenedor es justamente
                                lo que necesita almacén para recibir, así que
                                se muestra también en modo consulta. */}
                            <Button
                              size="sm"
                              className="btn"
                              color="secondary"
                              title="PDF por contenedor (recepcion)"
                              onClick={(e) =>
                                PDFContenedorSimple(
                                  a.fechaEmbarque,
                                  a.contenedor,
                                  a.fechaEstimada,
                                  a._id,
                                  a.numero
                                )
                              }
                            >
                              <i class="fas fa-clipboard-check"></i>
                            </Button>
                            {/* El resto de acciones sólo fuera de consulta */}
                            {!soloConsulta && (
                            <>
                            <Button
                              size="sm"
                              className="btn"
                              color="warning"
                              title="Archivos"
                              onClick={() => abrirArchivos(a._id, a.numero || a.contenedor)}
                            >
                              <i className="fas fa-folder-open"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fechaEmbarque,
                                  a.fechaEstimada,
                                  a.observaciones,
                                  a.contenedor,
                                  a.numero,
                                  a.recibido,
                                  a._id,
                                  a.noFactura,
                                  a.tipo
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {a.recibido === "No" ? (
                              <Button
                                color="danger"
                                size="sm"
                                title="Cancelar embarque (revierte OC, NotaCxP y ArticulosEmbarques)"
                                onClick={() => cancelarEmbarque(a._id, a.numero)}
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            ) : null}
                        {/* {a.recibido == "No" ? ( */}
                            {/* <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              EditArticulos(a._id, a.contenedor, a.idProveedor)
                            }
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button> */}
                          {/* ):undefined} */}

                            {/* Gastos, resumen de costeo, costeo y TC sólo
                                sirven para costos: sin permiso no se muestran */}
                            {verCostos && (
                            <>
                            <Button
                              color="primary"
                              id="Editar"
                              size="sm"
                              onClick={(e) => EditGastos(a._id)}
                            >
                              <i class="fas fa-dollar-sign"></i>
                            </Button>
                            <Button
                              color="success"
                              size="sm"
                              title="Resumen de gastos y cómo se prorratean entre los artículos"
                              onClick={() => abrirResumenCosteo(a._id)}
                            >
                              <i className="fas fa-balance-scale"></i>
                            </Button>
                            <Button
                              color="warning"
                              id="CosteoKasher"
                              size="sm"
                              onClick={(e) =>
                                EditArticulosKasher(
                                  a._id,
                                  a.totalCantidad,
                                  a.total_costo,
                                  a.tipoCambioUSDMXN,
                                  a.total_gasto,
                                  a.costeado,
                                  a.tipo,
                                  a.ivaPorcentaje
                                )
                              }
                            >
                              <i class="fas fa-calculator"></i>
                            </Button>
                            <Button
                              color="secondary"
                              id="EditarTC"
                              size="sm"
                              onClick={(e) =>
                                EditTC(a._id, a.tipoCambioUSDMXN)
                              }
                            >
                              <i class="fas fa-exchange-alt"></i>
                            </Button>
                            </>
                            )}
                            </>
                            )}
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* Los modales de costos no se abren sin el permiso Ver costos en compras */}
      <Modal size="lg" isOpen={verCostos && modalEditTC} toggle={toggleEditTC}>
        <ModalHeader toggle={toggleEditTC}>
          <h4>Editar Tipo de Cambio por Articulo</h4>
        </ModalHeader>
        <ModalBody>
          <Table>
            <thead>
              <tr>
                <th>Articulo</th>
                <th>Cantidad</th>
                <th>Tipo Cambio USD-MXN</th>
              </tr>
            </thead>
            <tbody>
              {articulosEmbTC.map((a, idx) => (
                <tr key={a.id}>
                  <td>{a.articulo}</td>
                  <td>{a.cantidad}</td>
                  <td>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={a.tipoCambioUSDMXN}
                      onChange={(e) => handleTCChange(idx, e.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveTC}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Embarque # {numeroEmbarque}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha Embarque</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEmbarque}
                required
                onChange={(e) => {
                  setFechaEmbarque(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label># Contenedor</Label>
              <Input
                type="text"
                placeholder="contenedor"
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>ETA de Arribo</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEstimada}
                required
                onChange={(e) => {
                  setFechaEstimada(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
          <Col md={2}>
                <Label>Recibido</Label>
                <Input
                  type="select"
                  value={recibidoEdit}
                  onChange={(e) => {
                    setRecibidoEdit(e.target.value);
                  }}
                >
                  <option value={"No"}>No</option>
                  <option value={"Si"}>Si</option>
                </Input>
            </Col>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
                <Label>No. Factura</Label>
                <Input
                  type="text"
                  value={noFactura}
                  onChange={(e) => {
                    setNoFactura(e.target.value);
                  }}
                />
            </Col>
            <Col md={2}>
                <Label>Tipo</Label>
                <Input
                  type="select"
                  value={tipoEdit}
                  onChange={(e) => setTipoEdit(e.target.value)}
                >
                  <option value="Taref">Taref</option>
                  <option value="Kasher">Kasher</option>
                </Input>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmbarques}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>Editar Contenedor # {contenedorEdit}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {/* <Col md={2}>
              <Label className="mr-sm-2">Proveedor</Label>
            </Col> */}
            <Col md={2}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">OC</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad OC</Label>
            </Col>
            {/* FOB sólo con el permiso de costos */}
            {verCostos && (
              <Col md={1}>
                <Label className="mr-sm-2">FOB</Label>
              </Col>
            )}
            <Col md={1}>
              <Label className="mr-sm-2">Cajas</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Pzas por Caja</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
          </Row>

          {articulosOrden.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                {/* <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="proveedor"
                    type="select"
                    value={inputField.proveedorOrden}
                    required
                    disabled
                  >
                    <option value="">Selecciona un Proveedor</option>
                    {proveedores.map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                  </Input>
                </Col> */}
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    disabled
                  >
                    <option value="">Selecciona un Articulo</option>
                    {articulos
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.nombre}</option>;
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="orden"
                    type="select"
                    value={inputField.articulosOrden}
                    required
                    disabled
                  >
                    <option value="">Selecciona una OC</option>
                    {articulosOC.map((a) => {
                      if (
                        a.articulos[0]._id == inputField.articulos &&
                        a.ordenesCompra[0].proveedores[0]._id ==
                          inputField.proveedorOrden
                      )
                        return (
                          <option value={a._id}>
                            OC {a.ordenesCompra[0].idOrdenCompra} / Cant{" "}
                            {a.cantidad}
                          </option>
                        );
                    })}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cantidadOC"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.cantidadOC}
                    disabled
                  />
                </Col>
                {verCostos && (
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="FOB"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.costo}
                      disabled
                    />
                  </Col>
                )}
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cajas"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.cajas}
                    onChange={(event) =>
                      handleChangeInputCantidadCajas(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="piezasPorCaja"
                    type="string"
                    value={inputField.piezasPorCaja}
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    onChange={(event) =>
                      handleChangeInputCantidad(inputField.id, event)
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}

<br />
          {/* Agregar Articulos */}

          {inputFieldsNuevos.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.articulos}
                      required
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulos
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="orden"
                      type="select"
                      value={inputField.articulosOrden}
                      required
                      onChange={(event) => {
                        BuscaOrden(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona una OC</option>
                      {articulosOC.map((a) => {
                        if (
                          a.articulos._id == inputField.articulos && /** Presenta error con  a.articulos[0]._id */
                          a.ordenesCompra[0].proveedores[0]._id == idProveedor
                        )
                          return (
                            <option value={a._id}>
                              OC {a.ordenesCompra[0].idOrdenCompra} / Cant{" "}
                              {a.cantidad}
                            </option>
                          );
                      })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidadOC"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cantidadOC}
                      disabled
                    />
                  </Col>
                  {verCostos && (
                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="FOB"
                        type="number"
                        min="0"
                        step="any"
                        value={inputField.costo}
                        disabled
                      />
                    </Col>
                  )}
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cajas}
                      onChange={(event) =>
                        handleChangeInputCantidadCajasNuevos(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="piezasPorCaja"
                      type="string"
                      value={inputField.piezasPorCaja}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadNuevos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}






          <Row>
            <Col md={12}>
              <h4 id="logoutBoton">
                TOTALES{" "}
                {new Intl.NumberFormat("en-US").format(totalCantidadEdit)} pzas.
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveEditArt}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal editar Gastos */}

      <Modal size="xl" isOpen={verCostos && modalEditGastos} toggle={toggleEditGastos}>
        <ModalHeader toggle={toggleEditGastos}>
          <h4>Editar Gastos Embarque</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveGastosEmbarque}>
            <Row>
              <Col md={12}>
                <Label className="mr-sm-2">Observaciones de los gastos</Label>
                <Input
                  type="text"
                  placeholder="Nota general: de qué son, qué falta, con quién se aclaró"
                  value={observacionesGastos}
                  onChange={(e) => setObservacionesGastos(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Button
                  size="sm"
                  color={gastosValidados === "Si" ? "success" : "secondary"}
                  onClick={() =>
                    setGastosValidados(gastosValidados === "Si" ? "No" : "Si")
                  }
                >
                  <i
                    className={
                      gastosValidados === "Si"
                        ? "fas fa-check-circle"
                        : "far fa-circle"
                    }
                  ></i>{" "}
                  {gastosValidados === "Si"
                    ? "Gastos validados"
                    : "Marcar gastos como validados"}
                </Button>{" "}
                <span style={{ fontSize: 12, color: "#666" }}>
                  {gastosValidados === "Si"
                    ? "Los gastos están completos y el embarque se puede costear."
                    : "Márcalos cuando estén todos cargados; se guarda al dar Guardar."}
                </span>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Concepto</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Estimado USD</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Real MXN</Label>
              </Col>
            </Row>
            {gastosEmbarque.map((ae) => (
              <div key={ae._id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={ae.conceptosGastosEmbarques[0]._id}
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={ae.estimado}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={ae.real}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {/* Agregar articulos */}
            {inputFieldsGastos.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={inputField.concepto}
                      onChange={(event) => BuscaGasto(inputField.id, event)}
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.estimado}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={inputField.real}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={setInputFieldsGastos.length === 1}
                      onClick={() => handleRemoveFieldsGastos(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsGastos}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>


      <Modal
        size="xxl"
        isOpen={verCostos && modalEditFOBKasher}
        toggle={toggleEditFOBKasher}
      >
        <ModalHeader toggle={toggleEditFOBKasher}>
          <h4>Costeo del embarque</h4>
          <Row style={{ alignItems: "center", marginTop: 8 }}>
            <Col md={3}>
              <Label style={{ fontSize: 13, marginBottom: 2 }}>Total Gastos</Label>
              <Input
                bsSize="sm"
                type="text"
                disabled
                value={new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalGastoPrecosteo)}
              />
            </Col>
            <Col md={3}>
              <Label style={{ fontSize: 13, marginBottom: 2 }}>TC del Contenedor</Label>
              <Input
                bsSize="sm"
                type="text"
                disabled
                value={new Intl.NumberFormat("en-US", { maximumFractionDigits: 4 }).format(tipoCambio)}
              />
            </Col>
            <Col md={3}>
              <Label style={{ fontSize: 13, marginBottom: 2 }}>
                TC de Gastos{" "}
                <i
                  className="fas fa-info-circle"
                  title="Los gastos se capturan en pesos, así que va 1. Sólo cámbialo si los gastos vinieran en dólares."
                ></i>
              </Label>
              <Input
                bsSize="sm"
                type="number"
                min="0"
                step="any"
                value={tipoCambioGastos}
                onChange={(e) => setTipoCambioGastos(Number(e.target.value) || 0)}
              />
            </Col>
            <Col md={2}>
              <Label style={{ fontSize: 13, marginBottom: 2 }}>
                IVA %{" "}
                <i
                  className="fas fa-info-circle"
                  title="IVA que se aplica al costear. Sólo afecta a los embarques Kasher."
                ></i>
              </Label>
              <Input
                bsSize="sm"
                type="number"
                min="0"
                step="any"
                value={ivaPorcentaje}
                disabled={tipoEmbarque !== "Kasher"}
                onChange={(e) => setIvaPorcentaje(Number(e.target.value) || 0)}
              />
            </Col>
            <Col md={3}>
              <Label style={{ fontSize: 13, marginBottom: 2 }}>Gastos en MXN</Label>
              <Input
                bsSize="sm"
                type="text"
                disabled
                value={new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "MXN",
                  maximumFractionDigits: 2,
                }).format(
                  Number(totalGastoPrecosteo) *
                    (Number(tipoCambioGastos) > 0
                      ? Number(tipoCambioGastos)
                      : 1)
                )}
              />
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Table bordered size="sm" responsive>
              <thead className="text-center">
                <tr>
                  <th>Artículo</th>
                  <th>Cantidad</th>
                  <th>FOB</th>
                  <th>TC</th>
                  <th>% FOB</th>
                  <th>Gasto Total</th>
                  <th>Total FOB USD</th>
                  <th>FOB Total Pesos</th>
                  <th>IGI % / Arancel</th>
                  <th>IGI</th>
                  <th>IVA</th>
                  <th>Impuestos</th>
                  <th>FOB Unit. Pesos</th>
                  <th>Gastos</th>
                  <th>Costo Unitario</th>
                </tr>
              </thead>

              <tbody>
                {articulosPedido.map((ae, index) => {
                  const calc = calcularCosteoKasher(ae);
                  const porcentajeFOB = Number(ae.porcentajeFOB || 0) * 100;
                  const gastoTotalArticulo = Number(ae.gastoTotalArticulo || 0);
                  const cantidad = calc.cantidad;
                  const costoFOB = calc.costoFOB;
                  const gastos = calc.gastos;
                  const igiPorcentaje = calc.igiPorcentaje;
                  const total = calc.totalFOB;
                  const declaradoPesos = calc.declaradoPesos;
                  const igi = calc.igi;
                  const iva = calc.iva;
                  const impuestos = calc.impuestos;
                  const fobUnitarioPesos = calc.fobUnitarioPesos;
                  const costoUnitario = calc.costoUnitario;

                  return (
                    <tr key={ae.id || ae._id}>
                      <td>
                        <Input bsSize="sm" type="text" disabled value={ae.articulo} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={cantidad} />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={Number(ae.costoUSD) || 0}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          step="any"
                          value={
                            ae.tipoCambioUSDMXN != null
                              ? ae.tipoCambioUSDMXN
                              : tipoCambio
                          }
                          onChange={(e) =>
                            handleTCArticuloChange(index, e.target.value)
                          }
                          style={{ backgroundColor: "#fffbcc" }}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={porcentajeFOB.toFixed(2)}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={gastoTotalArticulo.toFixed(2)}
                        />
                      </td>
                      {/* <td>
                        <Input
                          bsSize="sm"
                          name="comisionVendedorPorcentaje"
                          type="number"
                          value={ae.comisionVendedorPorcentaje}
                          onChange={(e) => handleComisionChange(index, e.target.value)}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          name="comisionVendedorCantidad"
                          type="number"
                          value={comision.toFixed(2)}
                          disabled
                        />
                      </td> */}
                      <td>
                        <Input bsSize="sm" type="number" disabled value={total.toFixed(2)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={declaradoPesos.toFixed(2)} />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={igiPorcentaje}
                        />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={igi.toFixed(2)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={iva.toFixed(2)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={impuestos.toFixed(2)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={fobUnitarioPesos.toFixed(2)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" value={gastos} disabled />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" disabled value={costoUnitario.toFixed(2)} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
                  <Button
                    type="button"
                    className="btn btn-warning ms-2"
                     onClick={saveFOBEmbarque}
                  >
                    Costear
                  </Button>
               
          </Form>
        </ModalBody>
      </Modal>

      {/* Resumen del costeo: gastos del embarque y su prorrateo por artículo */}
      <Modal size="xl" isOpen={verCostos && modalResumen} toggle={() => setModalResumen(!modalResumen)} style={{ maxWidth: "95%" }}>
        <ModalHeader toggle={() => setModalResumen(!modalResumen)}>
          {resumenCosteo ? (
            <h4>
              Costeo del embarque #{resumenCosteo.embarque.idEmbarques} · {resumenCosteo.embarque.contenedor}
              <small style={{ display: "block", fontSize: 13, color: "#6c757d", marginTop: 4 }}>
                {resumenCosteo.embarque.noFactura && resumenCosteo.embarque.noFactura !== "0"
                  ? `Factura ${resumenCosteo.embarque.noFactura} · `
                  : ""}
                {resumenCosteo.embarque.tipo} · TC contenedor {resumenCosteo.embarque.tipoCambioUSDMXN} ·{" "}
                {resumenCosteo.embarque.recibido === "Si" ? "Recibido" : "Sin recibir"} ·{" "}
                {resumenCosteo.embarque.costeado === "Si" ? "Costeado" : "Sin costear"}
              </small>
            </h4>
          ) : (
            <h4>Costeo del embarque</h4>
          )}
        </ModalHeader>
        <ModalBody>
          {!resumenCosteo ? (
            <div align="center">Cargando…</div>
          ) : (
            (() => {
              const r = resumenCosteo;
              const money = (n) =>
                new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(n) || 0);
              const num = (n, d = 2) => new Intl.NumberFormat("en-US", { maximumFractionDigits: d }).format(Number(n) || 0);
              const hayExcedidas = r.notas.some((n) => n.saldo + (difPreciosPorNota[n._id] || 0) < -0.005);
              return (
                <>
                  {r.desactualizado ? (
                    <div style={{ background: "#fff3cd", color: "#856404", padding: "8px 12px", borderRadius: 6, marginBottom: 12 }}>
                      Los costos guardados no corresponden a los gastos, precios o TC actuales del embarque
                      (gastos guardados {money(r.embarque.totalGastoGuardado)} · gastos capturados {money(r.gastos.total)}).{" "}
                      <Button size="sm" color="warning" disabled={guardandoResumen} onClick={recostearDesdeResumen}>
                        Recalcular costos
                      </Button>
                    </div>
                  ) : null}

                  <h6>1. Gastos del embarque</h6>
                  <Table size="sm" bordered style={{ maxWidth: 700 }}>
                    <thead>
                      <tr>
                        <th>Concepto</th>
                        <th style={{ textAlign: "right" }}>Estimado</th>
                        <th style={{ textAlign: "right" }}>Real</th>
                      </tr>
                    </thead>
                    <tbody>
                      {r.gastos.conceptos.map((g) => (
                        <tr key={g._id}>
                          <td>{g.concepto}</td>
                          <td align="right">{money(g.estimado)}</td>
                          <td align="right">{money(g.real)}</td>
                        </tr>
                      ))}
                      <tr style={{ fontWeight: "bold", borderTop: "2px solid #333" }}>
                        <td>Total</td>
                        <td align="right">{money(r.gastos.conceptos.reduce((t, g) => t + g.estimado, 0))}</td>
                        <td align="right">{money(r.gastos.total)}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <div style={{ fontSize: 13, color: "#555", marginBottom: 14 }}>
                    Gastos validados: <b>{r.embarque.gastosValidados}</b>
                    {r.embarque.tipoCambioGastos !== 1 ? <> · TC de gastos {r.embarque.tipoCambioGastos} ({money(r.gastos.totalPesos)} en pesos)</> : null}
                    {r.embarque.observacionesGastos && r.embarque.observacionesGastos !== "NA" ? <> · {r.embarque.observacionesGastos}</> : null}
                  </div>

                  <h6>2. Cómo se prorratean entre los artículos</h6>
                  <div style={{ fontSize: 13, color: "#555", marginBottom: 6 }}>
                    A cada artículo le toca de los gastos lo que pesa su FOB en el FOB del embarque (% FOB).{" "}
                    <b>Costo unitario</b> = FOB × TC + gasto por pieza
                    {r.embarque.tipo === "Kasher" ? ` + impuestos (IGI e IVA ${r.embarque.ivaPorcentaje}%)` : ""}.
                  </div>
                  <Table size="sm" bordered className="table-responsive-xl">
                    <thead>
                      <tr style={{ fontSize: 12 }}>
                        <th>Artículo</th>
                        <th>Proveedor</th>
                        <th style={{ textAlign: "right" }}>Piezas</th>
                        <th style={{ textAlign: "right" }}>FOB USD</th>
                        {editandoPrecios ? <th style={{ textAlign: "right" }}>Nuevo FOB USD</th> : null}
                        <th style={{ textAlign: "right" }}>TC</th>
                        <th style={{ textAlign: "right" }}>FOB total USD</th>
                        <th style={{ textAlign: "right" }}>% FOB</th>
                        <th style={{ textAlign: "right" }}>Gasto asignado</th>
                        <th style={{ textAlign: "right" }}>Gasto por pieza</th>
                        {r.embarque.tipo === "Kasher" ? <th style={{ textAlign: "right" }}>Impuestos por pieza</th> : null}
                        <th style={{ textAlign: "right" }}>Costo unitario</th>
                        <th style={{ textAlign: "right" }}>Costo guardado</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: 13 }}>
                      {r.renglones.map((x) => {
                        const distinto = Math.abs(x.costoUnitario - x.costoGuardado) >= 0.01;
                        return (
                          <tr key={x._id}>
                            <td>
                              {x.codigo} <span style={{ color: "#6c757d" }}>{x.nombre}</span>
                            </td>
                            <td>{x.proveedor}</td>
                            <td align="right">{num(x.cantidad)}</td>
                            <td align="right">{num(x.costoFOB, 4)}</td>
                            {editandoPrecios ? (
                              <td align="right">
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  step="any"
                                  style={{ width: 110, display: "inline-block" }}
                                  value={preciosEdit[x._id] ?? ""}
                                  placeholder={String(x.costoFOB)}
                                  onChange={(e) => setPreciosEdit({ ...preciosEdit, [x._id]: e.target.value })}
                                />
                              </td>
                            ) : null}
                            <td align="right" title={x.tcSospechoso ? `TC capturado ${x.tipoCambioCapturado}: no es válido, se usa el del contenedor` : undefined}>
                              {num(x.tipoCambio, 4)}
                              {x.tcSospechoso ? <span style={{ color: "#dc3545" }}> ⚠</span> : null}
                            </td>
                            <td align="right">{num(x.totalFOB)}</td>
                            <td align="right">{(x.porcentajeFOB * 100).toFixed(2)}%</td>
                            <td align="right">{money(x.gastoTotalArticulo)}</td>
                            <td align="right">{money(x.gastos)}</td>
                            {r.embarque.tipo === "Kasher" ? (
                              <td align="right">{money(x.cantidad > 0 ? x.impuestos / x.cantidad : 0)}</td>
                            ) : null}
                            <td align="right">
                              <b>{money(x.costoUnitario)}</b>
                            </td>
                            <td align="right" style={distinto ? { color: "#dc3545", fontWeight: 600 } : undefined}>
                              {money(x.costoGuardado)}
                            </td>
                          </tr>
                        );
                      })}
                      <tr style={{ fontWeight: "bold", borderTop: "2px solid #333" }}>
                        <td colSpan={2} align="right">Totales</td>
                        <td align="right">{num(r.totales.cantidad)}</td>
                        <td></td>
                        {editandoPrecios ? <td></td> : null}
                        <td></td>
                        <td align="right">{num(r.totales.fobUSD)}</td>
                        <td align="right">100%</td>
                        <td align="right">{money(r.totales.gastos)}</td>
                        <td></td>
                        {r.embarque.tipo === "Kasher" ? <td align="right">{money(r.totales.impuestos)}</td> : null}
                        <td align="right">{money(r.totales.costoTotal)}</td>
                        <td align="right">{money(r.totales.costoTotalGuardado)}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <div style={{ fontSize: 12, color: "#6c757d" }}>
                    Totales de costo = costo unitario × piezas. En rojo, el costo guardado que no coincide con el calculado.
                  </div>

                  {editandoPrecios ? (
                    <>
                      <h6 style={{ marginTop: 14 }}>3. Lo que se le debe a cada proveedor</h6>
                      <Table size="sm" bordered style={{ maxWidth: 800 }}>
                        <thead>
                          <tr>
                            <th>Nota</th>
                            <th>Proveedor</th>
                            <th style={{ textAlign: "right" }}>Total</th>
                            <th style={{ textAlign: "right" }}>Saldo</th>
                            <th style={{ textAlign: "right" }}>Cambio</th>
                            <th style={{ textAlign: "right" }}>Saldo nuevo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {r.notas.map((n) => {
                            const dif = difPreciosPorNota[n._id] || 0;
                            const excede = n.saldo + dif < -0.005;
                            return (
                              <tr key={n._id} style={excede ? { background: "#f8d7da" } : undefined}>
                                <td>{n.idNotasCxP}</td>
                                <td>{n.proveedor}</td>
                                <td align="right">{money(n.total_costo)}</td>
                                <td align="right">{money(n.saldo)}</td>
                                <td align="right">{dif ? money(dif) : "-"}</td>
                                <td align="right">
                                  {money(n.saldo + dif)}
                                  {excede ? <div style={{ fontSize: 12 }}>La baja no puede ser mayor al saldo</div> : null}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <div style={{ fontSize: 13, color: "#555", marginBottom: 8 }}>
                        Importes en dólares. Bajar el precio sólo se puede hasta lo que todavía se le debe en esa nota; subirlo
                        aumenta lo que se le debe. Al guardar se recalcula el costo de los artículos y de lo que ya se vendió.
                      </div>
                      <Row>
                        <Col md={6}>
                          <Label>Motivo</Label>
                          <Input
                            bsSize="sm"
                            type="text"
                            value={motivoPrecios}
                            placeholder="Ej. descuento negociado con el proveedor"
                            onChange={(e) => setMotivoPrecios(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  <div style={{ marginTop: 16, display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Button size="sm" color="primary" onClick={excelResumen}>
                      Excel <i className="far fa-file-excel"></i>
                    </Button>
                    {r.embarque.costeado === "Si" && !r.desactualizado ? (
                      <Button size="sm" color="secondary" disabled={guardandoResumen} onClick={recostearDesdeResumen}>
                        Recalcular costos
                      </Button>
                    ) : null}
                    {user.menu_admin && r.embarque.recibido === "Si" ? (
                      editandoPrecios ? (
                        <>
                          <Button size="sm" color="success" disabled={guardandoResumen || hayExcedidas} onClick={guardarPrecios}>
                            Guardar precios
                          </Button>
                          <Button
                            size="sm"
                            color="secondary"
                            onClick={() => {
                              setEditandoPrecios(false);
                              setPreciosEdit({});
                            }}
                          >
                            Cancelar
                          </Button>
                        </>
                      ) : (
                        <Button size="sm" color="warning" onClick={() => setEditandoPrecios(true)}>
                          Editar precios del proveedor
                        </Button>
                      )
                    ) : null}
                  </div>
                </>
              );
            })()
          )}
        </ModalBody>
      </Modal>

      {/* W9: Modal archivos del embarque */}
      <Modal size="lg" isOpen={modalArchivos} toggle={() => setModalArchivos(!modalArchivos)}>
        <ModalHeader toggle={() => setModalArchivos(!modalArchivos)}>
          Archivos Embarque {archivosEmbarqueNum}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Nombre</Label>
              <Input
                type="text"
                placeholder="Ej. BL, Factura proveedor, etc."
                value={archivoNombre}
                onChange={(e) => setArchivoNombre(e.target.value)}
              />
            </Col>
            <Col md={5}>
              <Label>Archivo (PDF o imagen)</Label>
              <Input
                type="file"
                accept="application/pdf,image/*"
                onChange={(e) => setArchivoFile(e.target.files[0])}
              />
            </Col>
            <Col md={3} style={{ display: "flex", alignItems: "flex-end" }}>
              <Button color="success" onClick={subirArchivoEmbarque}>
                <i className="fas fa-upload"></i> Subir
              </Button>
            </Col>
          </Row>
          <hr />
          <h5>Archivos del embarque</h5>
          {archivosEmbarque.length === 0 ? (
            <p style={{ color: "#888" }}>Sin archivos.</p>
          ) : (
            <ul>
              {archivosEmbarque.map((a) => (
                <li key={a._id}>
                  <a
                    href={a.url}
                    onClick={(e) => { e.preventDefault(); setPreviewArchivo(a); }}
                    style={{ cursor: "pointer", color: "#B02307", fontWeight: 600 }}
                  >
                    [{a.tipo}] {a.nombre}
                  </a>
                  {a.fecha ? <small style={{ marginLeft: 8, color: "#888" }}>({a.fecha})</small> : null}
                </li>
              ))}
            </ul>
          )}
        </ModalBody>
      </Modal>

      <Modal
        size="xl"
        isOpen={!!previewArchivo}
        toggle={() => setPreviewArchivo(null)}
      >
        <ModalHeader toggle={() => setPreviewArchivo(null)}>
          {previewArchivo?.nombre || ""}
        </ModalHeader>
        <ModalBody style={{ textAlign: "center" }}>
          {previewArchivo?.tipo === "PDF" ? (
            <iframe
              title={previewArchivo?.nombre}
              src={previewArchivo?.url}
              style={{ width: "100%", height: "70vh", border: "1px solid #ccc" }}
            />
          ) : previewArchivo ? (
            <img
              src={previewArchivo.url}
              alt={previewArchivo.nombre}
              style={{ maxWidth: "100%", maxHeight: "70vh", border: "1px solid #ccc" }}
            />
          ) : null}
          <div style={{ marginTop: 12, display: "flex", gap: 10, justifyContent: "center" }}>
            <a
              href={previewArchivo?.url}
              target="_blank"
              rel="noopener noreferrer"
              download={previewArchivo?.nombre}
              className="btn btn-primary"
            >
              <i className="fas fa-download" /> Descargar
            </a>
            <Button color="danger" onClick={() => eliminarArchivoEmbarque(previewArchivo)}>
              <i className="fas fa-trash" /> Eliminar
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoEmbarques;
